import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../services/api";

export const useDistributorDelete = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id) => {
      const res = await api.delete(`/distributor/view/delete/${id}`);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["viewdistributor"]);
    },
  });
};
